import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import ReactGA from 'react-ga'
import {observer, inject} from 'mobx-react'
import {Spin, notification} from 'antd'
import ErrorBoundary from './ErrorBoundary'
import App from './App'
import Landing from './Landing'
import InternalRedirect from './InternalRedirect'

@withRouter
@inject('store') @observer
class AppWrapper extends Component {
  componentDidMount() {
    const {auth, user} = this.props.store
    if (auth.isLoggedIn) {
      user.getUserData()
      this.props.store.getSettings()
    }
    this.unlisten = this.props.history.listen(this.historyListener)
  }
  componentWillUnmount() {
    this.unlisten()
  }
  historyListener = (location) => {
    const page = location.pathname
    ReactGA.set({page})
    ReactGA.pageview(page)
    notification.destroy()
  }
  render() {
    const {auth, user} = this.props.store
    return(
      <div id='wrapper'>
        <ErrorBoundary>
          {!auth.isLoggedIn
            ? <Landing/>
            : user.checkingLogin
              ? <Spin size='large'>
                <div style={{height: '100vh'}}/>
              </Spin>
              : <App/>
          }
          <InternalRedirect/>
        </ErrorBoundary>
      </div>
    )
  }
}

export default AppWrapper
